import { ArrowRightIcon } from '../../assets/icons';
import { TradePair } from '../../context/chart/chartTypes';
import { formatPercentages } from '../../helpers';

type AssetTypeProps = {
    tradePair: TradePair | undefined;
    isShort: boolean;
    leverage?: string;
    newLeverage?: string;
    withUSD?: boolean;
};

const AssetType: React.FC<AssetTypeProps> = ({
    tradePair,
    isShort,
    leverage,
    newLeverage,
    withUSD = false,
}) => {
    return (
        <div className='asset-type'>
            <span>
                {tradePair
                    ? (withUSD
                          ? tradePair.name.replaceAll(' ', '')
                          : tradePair.name.split('/')[0]
                      ).trim()
                    : 'BTC'}
                &nbsp;
            </span>
            <span className={isShort ? 'short' : 'long'}>
                {isShort ? 'Short' : 'Long'}
            </span>
            {leverage && (
                <>
                    &nbsp;
                    {formatPercentages(leverage)}x
                </>
            )}
            {newLeverage && (
                <>
                    <ArrowRightIcon />
                    {formatPercentages(newLeverage)}x
                </>
            )}
        </div>
    );
};

export default AssetType;
